<template>
    <svg :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <path d="M44.1,29.8H5.9c-1.9,0-3.5,1.6-3.5,3.5v6.3c0,1.9,1.6,3.5,3.5,3.5h38.2c1.9,0,3.5-1.6,3.5-3.5v-6.3c0-1.9-1.6-3.5-3.5-3.5ZM5.4,39.7v-6.3c0-.3.2-.5.5-.5h17.6v7.4H5.9c-.3,0-.5-.2-.5-.5ZM44.6,39.7c0,.3-.2.5-.5.5h-17.6v-7.4h17.6c.3,0,.5.2.5.5v6.3Z"/>
        <path d="M44.1,15.8h-14.3c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5h14.3c.3,0,.5.2.5.5v5.3c0,.3-.2.5-.5.5H5.9c-.3,0-.5-.2-.5-.5v-5.3c0-.3.2-.5.5-.5h14.2c.8,0,1.5-.7,1.5-1.5s-.7-1.5-1.5-1.5H5.9c-1.9,0-3.5,1.6-3.5,3.5v5.3c0,1.9,1.6,3.5,3.5,3.5h38.2c1.9,0,3.5-1.6,3.5-3.5v-5.3c0-1.9-1.6-3.5-3.5-3.5Z"/>
        <path d="M23.1,12.4l.4-.4v10.6c0,.8.7,1.5,1.5,1.5s1.5-.7,1.5-1.5v-10.6l.4.4c.3.3.7.4,1.1.4s.8-.1,1.1-.4c.6-.6.6-1.5,0-2.1l-3-3c-.6-.6-1.5-.6-2.1,0l-3,3c-.6.6-.6,1.5,0,2.1s1.5.6,2.1,0Z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>